import { FC } from 'react';
import { Dialog, DialogContent, Button, Typography, Box } from '@mui/material';

interface EmailSwitchModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const EmailSwitchModal: FC<EmailSwitchModalProps> = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={() => {}} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogContent sx={{ marginBottom: 3 }}>
        <Typography align="center" mt={2} mb={4}>
          Would you like to set up email login?
        </Typography>

        <Box display="flex" flexDirection="row" gap={2} justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
            sx={{
              minWidth: 120,
              textTransform: 'none',
              borderRadius: '5px',
              fontWeight: 500,
              backgroundColor: '#3f51b5',
              '&:hover': { backgroundColor: '#354497' },
            }}>
            Not Now
          </Button>

          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              minWidth: 120,
              textTransform: 'none',
              borderRadius: '5px',
              fontWeight: 500,
              backgroundColor: '#3f51b5',
              '&:hover': { backgroundColor: '#354497' },
            }}>
            Yes
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
